// extracted by mini-css-extract-plugin
export var tosLink = "_bt-0";